import * as React from "react";
import { imgSrc } from "src/components/PlmUploader/imgSrc";
import styles from "./Bom2aColorCell.module.less";
import {
  Bom2aEdPositionRow,
  EdBom2aColorModel,
} from "../../../Bom2aPositionsTypes";
import { Bom2aPositionsStore } from "../../../Bom2aPositionsStore";
import { Bom2aColorInfo, Bom2aColorModal } from "./Bom2aColorModal";

type PropsBom2aColorCell = {
  row: Bom2aEdPositionRow;
  colorModel: EdBom2aColorModel | undefined;
  store: Bom2aPositionsStore;
  disabled?: boolean;
};

export const Bom2aColorCell: React.FC<PropsBom2aColorCell> = (props) => {
  const { row, colorModel, store, disabled } = props;
  const [edit, setEdit] = React.useState(false);
  if (!colorModel) return null;
  const { fields: modelFields, color } = colorModel.bomPositionColorModel;
  return (
    <>
      <button
        className={styles.box}
        type="button"
        disabled={disabled}
        onClick={() => {
          setEdit(true);
        }}
      >
        <SmallImg src={modelFields.colorReference.value} />
        <div>{modelFields.colorManual.value}</div>
        <div>{modelFields.comment.value}</div>
        <ColorBox color={color.hex.value} />
        <div>{color.article.value}</div>
        <div>{color.name.value}</div>
      </button>
      <Bom2aColorModal
        open={edit}
        close={() => setEdit(false)}
        initialData={colorModel}
        save={(data: Bom2aColorInfo) =>
          store.saveColor(row.id, colorModel, data)
        }
      />
    </>
  );
};

type PropsSmallImg = {
  src: string | null | undefined;
};
const SmallImg: React.FC<PropsSmallImg> = ({ src }) => {
  if (!src) return null;
  return (
    <div>
      <img src={imgSrc(src, "small")} alt="" className={styles.smallImage} />
    </div>
  );
};

type PropsColorBox = {
  color: string | null | undefined;
};
const ColorBox: React.FC<PropsColorBox> = ({ color }) => {
  if (!color) return null;
  return (
    <div>
      <div
        className={styles.colorBox}
        style={{ background: color }}
        title={color}
      />
    </div>
  );
};
